export default "__VITE_ASSET__DqbqqFpm__"